'use client';

import { Typography, theme, IcChevronRight } from '@bgzt/ui';
import { LinkByEnvironment } from '~/components';
import { PROMOTION_2025_04_MANDARAKE } from '~/app/_constants/promotion';

import styles from './MandarakePromotionBanner.module.css';

type Props = {
  discountRate?: number;
};

export const MandarakePromotionBanner = ({ discountRate }: Props) => {
  return (
    <LinkByEnvironment href={PROMOTION_2025_04_MANDARAKE.EXHIBITION_URL} target="_blank">
      <div className={styles.container}>
        <Typography variant="L10" color={'gray-900'}>
          만다라케 상품
        </Typography>
        <Typography variant="L9" color={'red-500'}>
          {discountRate && `무제한 ${discountRate}% `}
          할인
        </Typography>
        <Typography variant="L10" color={'gray-900'}>
          진행중
        </Typography>
        <IcChevronRight fill={theme.colors['gray-500']} size={10} />
      </div>
    </LinkByEnvironment>
  );
};
